import { Modal, ModalBody, Row, Col } from "reactstrap";
import axiosInstance from "../../../axios-instance";
import { useEffect, useState } from "react";
import { connect, useDispatch } from "react-redux";
import {
  SET_IS_LOADING,
} from "../../../actions/types";
import UpdateCardModal from "./update-card-modal";
import Loader from "../../../components/Loader/Loader";
import { notification } from "../../../utils/utility";


const UpgradeToTeamModal = ({toggle, currentPlanPeriodType, getUserAndPlans}) => {
    const dispatch = useDispatch();
    const [data, setData] = useState(null);
    const [showChangeCardModal, setShowChangeCardModal] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [loadingSentence, setLoadingSentence] = useState(null);

    useEffect(() => {
        const planId = 4 // team
        dispatch({
            type: SET_IS_LOADING,
            payload: true,
        });
        axiosInstance.get(`/admin/get-prorated-charges/${planId}/${currentPlanPeriodType}`)
            .then((res) => {
                if (res.data.success) {
                    setData(res.data);
                }  
                dispatch({
                    type: SET_IS_LOADING,
                    payload: false,
                });
            })
            .catch((err) => {
                dispatch({
                    type: SET_IS_LOADING,
                    payload: false,
                });
                console.log(err);
            });
    }, []);

    /**
     * upgrade plan handler
     * @param {*} data
     */
    const upgradePlanHandler = async (data) => {
        dispatch({
            type: SET_IS_LOADING,
            payload: true,
        });

        const res = await axiosInstance.post("/admin/subscription/update", {
            plan_id: 4, // team
            plan_type: currentPlanPeriodType
        });

        dispatch({
            type: SET_IS_LOADING,
            payload: false,
        });

        if (res.data.success) {
            notification.success(res.data.message);
            setLoadingSentence("Please wait, your subscription is being updated. This may take a few moments.");
            setIsLoading(true);
            setTimeout(() => {
                getUserAndPlans();
                setIsLoading(false);
            }, 15000);
        } else {
            notification.error(res.data.message);
        }
    };
  

    return (
        <>
        <Loader isShowLoader={isLoading} loadingText={loadingSentence} />
        {showChangeCardModal && <UpdateCardModal toggle={setShowChangeCardModal}/>}
        <Modal isOpen={true} toggle={toggle}>
            <ModalBody>
                <div className="">
                    <div className="eventdetailsaddbox rd_modalvieew">
                        <div className="box_content rd_modalboxcontent">
                            <div className="rd_inputselectheadermodalsetting">
                                <button className="rd_colsebtn" onClick={toggle}></button>
                            </div>
                            <h3 className="rd_modalheadertext rd_modalheadertextleft">
                                Upgrade to Teams
                            </h3>
                            <p className="rd_modalheadertext rd_modalheadertextleft">
                                <span style={{color:"#FE9920", fontWeight:"700"}}>
                                    Prices are in USD
                                </span>
                            </p>
                        
                            <p className="rd_modalheadertextparath mt-5 mb-3">
                                Starting {" "}
                                <span style={{color:"#FE9920", fontWeight:"700"}}>
                                    {data?.next_billing_date}
                                </span>
                                {" "} your {currentPlanPeriodType === "monthly" ? "monthly" : "anually"} bill
                                will be {" "}
                                <span style={{color:"#FE9920", fontWeight:"700"}}>
                                    ${data?.new_monthly_amount}
                                </span> 
                                    
                            </p>

                            <p className="rd_modalheadertextparath mt-3 mb-3">
                                An estimated prorated charge of {" "}
                                <span style={{color:"#FE9920", fontWeight:"700"}}>${data?.prorated_amount}</span> 
                                {" "}will be applied on your{" "}
                                <span style={{color:"#FE9920", fontWeight:"700"}}>{data?.card_brand}</span> 
                                    {" "} ending with {" "} 
                                <span style={{color:"#FE9920", fontWeight:"700"}}>{data?.card_last_four}</span>
                                .
                            </p>

                            <Row className="mb-3">
                                <Col className="text-center">
                                <button className="btn btn_success btn-sm" onClick={() => setShowChangeCardModal(true)}>Change Card</button>
                                </Col>
                            </Row>

                            <div className="rd_cancelappbtnmodal">
                                <button className="btn btn-danger" onClick={toggle}>
                                    Cancel
                                </button>
                                <button
                                    className="btn btn-app"
                                    onClick={() => {
                                        upgradePlanHandler({});
                                        toggle();
                                    }}
                                >
                                    Confirm
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </ModalBody>
        </Modal>
        </>
    )
}



const mapStateToProps = (state) => ({
  subscription: state.subscription,
});

export default connect(mapStateToProps, null)(UpgradeToTeamModal);
